module.exports = __webpack_public_path__ + "img/3.8cf77a07.webp";